import type { ContactLocation, ContactLocationCreateInput, ContactRole } from "@/graphql/codegen/graphql"
import type { ContactLocationAddFormValues, ContactLocationEditFormValues } from "@/schemas/contactFormSchema"

export const convertContactLocationsToEditFormValues = (
  contactLocations: ContactLocation[]
): ContactLocationEditFormValues[] => {
  const locationIdRolesMap = new Map<string, ContactRole[]>()

  contactLocations.forEach(({ locationId, contactRole }) => {
    const locationRoles = locationIdRolesMap.get(locationId) ?? []
    locationIdRolesMap.set(locationId, [...locationRoles, contactRole!])
  })

  const formValues: ContactLocationEditFormValues[] = []
  locationIdRolesMap.forEach((roles, locationId) =>
    formValues.push({
      locationId,
      currentRoles: roles,
      newRoles: [],
    })
  )

  return formValues
}

export const serializeContactLocationAddFormValues = (
  contactId: string,
  locationRoles: ContactLocationAddFormValues[]
): ContactLocationCreateInput[] =>
  locationRoles
    .filter(({ locationId }) => !!locationId)
    .flatMap(({ locationId, roles, isPrimary }) =>
      roles.map((role) => ({ contactId, locationId, contactRole: role as ContactRole, isPrimary }))
    )

export const serializeContactLocationEditFormValues = (
  contactId: string,
  locationRoles: ContactLocationEditFormValues[]
): ContactLocationCreateInput[] =>
  locationRoles.flatMap(({ locationId, currentRoles, newRoles }) =>
    [...currentRoles, ...newRoles].map((role) => ({ contactId, locationId, contactRole: role as ContactRole }))
  )
